import { useIsFeatureEnabled } from 'tradera/hooks/use-is-feature-enabled';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';

type ConditionalRenderSectionProps = {
    children: React.ReactNode;
    featureToggle?: string;
    onlyForLoggedInUsers?: boolean;
    onlyForLoggedOutUsers?: boolean;
};
export const ConditionalRenderSection = ({
    children,
    featureToggle,
    onlyForLoggedInUsers,
    onlyForLoggedOutUsers
}: ConditionalRenderSectionProps) => {
    const isLoggedIn = useIsLoggedIn();
    const isFeatureEnabled = useIsFeatureEnabled(featureToggle);

    if (onlyForLoggedInUsers && onlyForLoggedOutUsers) {
        throw new Error(
            'ConditionalRenderSection: onlyForLoggedInUsers and onlyForLoggedOutUsers cannot be true at the same time'
        );
    }

    const passesLoginCheck = !onlyForLoggedInUsers || isLoggedIn;
    const passesLogoutCheck = !onlyForLoggedOutUsers || !isLoggedIn;
    const passesFeatureTogglecheck = !featureToggle || isFeatureEnabled;

    return passesLoginCheck && passesLogoutCheck && passesFeatureTogglecheck ? (
        <>{children}</>
    ) : null;
};
